import React from "react";
import HypenaFooter from "./HypenaFooter";

const Footer = () => <HypenaFooter />;

export default Footer;
